import { endOfMonth, format, startOfMonth, subMonths } from 'date-fns';
import { CHANNELS, DATE_FORMAT, InvoicingSummaryCompany } from './invoicing-constants';

export interface InvoicingDateRange {
  start: string;
  end: string;
}

export const defaultInvoicingDates = (): InvoicingDateRange => {
  const lastMonth = subMonths(new Date(), 1);
  return {
    start: format(startOfMonth(lastMonth), DATE_FORMAT),
    end: format(endOfMonth(lastMonth), DATE_FORMAT)
  };
};

export const toCost = (num: number): string => `$${(Math.round(num * 100) / 100).toLocaleString()}`;

const capitalize = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

export const buildInvoicingSummaryRows = (companies: InvoicingSummaryCompany[]): string[][] => {
  const header = ['Company', 'Linear', 'ICON', ...CHANNELS.map(capitalize)];
  const rows = companies.map(company => {
    const channelFlags = CHANNELS.map(channel => {
      const impressions = company[`${channel}ImpressionsTotal` as keyof InvoicingSummaryCompany] as
        number | undefined;
      return impressions && impressions > 1000 ? 'T' : 'F';
    });
    return [
      company.company,
      company.linearSpendTotal ? 'T' : 'F',
      company.linearIconSpendTotal ? 'T' : 'F',
      ...channelFlags
    ];
  });
  return [header, ...rows];
};
